import React from 'react';
import { ThemeProvider } from '@mui/material/styles';
import { Routes, Route, Navigate } from 'react-router-dom';
import { theme } from './theme';
import SystemStart from './Components/SystemStart';
import MainLayout from './Components/Layout/MainLayout';
import Dashboard from './Components/Dashboard/Dashboard';
import Record from './Components/Record/Record';
import TY2 from './Components/TY2';
import Pharmacy from './Components/Pharmacy/Pharmacy';
import Login from './Components/Login';
import Accounts from './Components/Accounts/Accounts';
import Doctors from './Components/Doctors/Doctors';
import AdminPanel from './Components/AdminPanel';
import TY from './Components/TY';
import IdleLogout from './Components/IdleLogout';
import Wards from './Components/Wards/Wards';
import Procurement from './Components/Procurement/Procurement';
import Laboratory from './Components/Laboratory/Laboratory';
import Claims from './Components/Claims/Claims';
import HealthInformation from './Components/Health Information/HealthInformation';
import Emergency from './Components/Emergency/Emergency';
import HumanResources from './Components/HumanResources/HumanResources';
import NetworkStatusBanner from './Components/NetworkStatusBanner';
import DomainRenewalPrompt from './Components/Billing/DomainRenewalPrompt';

function App() {
  return (
    <ThemeProvider theme={theme}>
      {/* Sits outside <Routes> so the banner and axios interceptor persist
          across every screen, including Login. */}
      <NetworkStatusBanner />
      {/* Domain renewal prompt. Mounted here so it can surface over any screen
          after login; it self-suppresses on the login page and whenever the
          current billing period has been acknowledged. */}
      <DomainRenewalPrompt />
      <IdleLogout timeout={10 * 60 * 1000}>  {/* 10 minutes */}
        <Routes>
          <Route path="/" element={<Login />} />
          <Route path="/dashboard" element={<MainLayout />}>
            <Route index element={<Dashboard />} />
            <Route path="dashboard" element={<Dashboard />} />
            <Route path="Record" element={<Record />} />
            <Route path="Procurement" element={<Procurement />} />
            <Route path="Pharmacy" element={<Pharmacy />} />
            <Route path="Accounts" element={<Accounts />} />
            <Route path="Doctors" element={<Doctors />} />
            <Route path="Wards" element={<Wards />} />
            <Route path="TY" element={<TY />} />
            <Route path="TY2" element={<TY2 />} />
            <Route path="Laboratory" element={<Laboratory />} />
            <Route path="Claims" element={<Claims />} />
            <Route path="HealthInformation" element={<HealthInformation />} />
            <Route path="Emergency" element={<Emergency />} />
            <Route path="HumanResources" element={<HumanResources />} />
            <Route path="AdminPanel" element={<AdminPanel />} />
          </Route>
        </Routes>
      </IdleLogout>
    </ThemeProvider>
  );
}

export default App;
